import React from "react";
import { Link } from "react-router-dom";

const CredentialCard = ({ employee }) => {
  debugger
  const serverHost = `http://${window.location.hostname.includes('localhost') ? 'localhost:4000' : 'unioninformatica.org:4000'}`;
  const profileImage = employee?.credentialData?.credentialPhoto  ? serverHost+ employee?.credentialData?.credentialPhoto : 'https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg';
  return (
    <>
    <div className="credencial">
    <div className="header-mobile">
    <h1 className="text-xl font-semibold">¡Hola, {employee.name.split(' ')[0]}!</h1>
    <Link to='/afiliado/edit-afiliado'  className="btn btn-light" >
  <i className="fas fa-edit"></i> Editar
</Link>
</div>

    <div className="credential-card"  >
      <div className="flex justify-between items-center">
        <div>
          <img src="https://unioninformatica.org/wp-content/uploads/2022/11/logoui2-768x119.png" alt="Informática Logo" className="logo-ui"/>
        </div>
        <div>
          <img
            src={profileImage}
            alt="Profile"
            className="profile-image"
          />
        </div>
      </div>

      <div className="mt-2">
        <h2 className="text-xl font-bold text-gray-800 afiliado-name">
          {employee.name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}
        </h2>
        
        <div className="mt-2">
          <div className="flex-col">
            <span className="text-xs text-gray-500">Número de Afiliado</span>
            <span class="text-base font-semibold">{employee.credentialData.credentialNumber}</span>
          </div>
          
          <div className="flex-col mt-1">
            <span className="text-xs text-gray-500">Número de documento</span>
            <span class="text-base font-semibold">{employee.dni}</span>
          </div>

          <div className="flex-col mt-1 desktop-only">
            <span className="text-xs text-gray-500">CUIL</span>
            <span class="text-base font-semibold">{employee.cuil}</span>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="flex justify-between items-center">
          <span className=" font-semibold">Afiliado Titular</span>
          <svg className="qr-code" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <rect x="7" y="7" width="3" height="3"></rect>
            <rect x="14" y="7" width="3" height="3"></rect>
            <rect x="7" y="14" width="3" height="3"></rect>
          </svg>
        </div>

        <p className="text-xs text-gray-500 text-center mt-3">
          Esta credencial es personal e intransferible para uso exclusivo del afiliado y debe ser acompañada siempre con su DNI.
        </p>
      </div>
    </div>
    </div>
    </>
  );
};

export default CredentialCard;
